import React, { useEffect, useRef } from "react";
import { decodeHtml } from "../../../utils/richText";

// Scripts inserted through innerHTML are inert per HTML spec; re-create each one as a fresh
// element so embeds (widgets, trackers, the ai12z search) actually run.
export const activateScripts = (host) => {
    host.querySelectorAll("script").forEach((inert) => {
        const script = document.createElement("script");
        [...inert.attributes].forEach((attr) => script.setAttribute(attr.name, attr.value));
        script.textContent = inert.textContent;
        inert.replaceWith(script);
    });
};

// Renders authored raw HTML as-is. The delivery API HTML-escapes the stored value, so it is
// decoded first. Deliberately unsanitized: the fields behind it are marked for trusted
// authors (Interactive Block, header search embeds).
const RawHtml = ({ html, className, as: Tag = "div" }) => {
    const hostRef = useRef(null);
    const markup = decodeHtml(html);

    useEffect(() => {
        if (hostRef.current && markup) activateScripts(hostRef.current);
    }, [markup]);

    if (!markup) return null;

    return <Tag ref={hostRef} className={className} dangerouslySetInnerHTML={{ __html: markup }} />;
};

export default RawHtml;